import {
  Review,
  ReviewReviewer,
} from '~/components/UI/ProductReviewsList/ProductReview'

import { getParsedJSONValues } from '~/utils/get-parsed-json'

import serializeDate from '~/data/serialize-date'

const JUDGEME_VERIFIED_STATUS = 'confirmed-buyer'

export function serializeReview(rawReview, locale): Review {
  const [title] = getParsedJSONValues(rawReview?.title, ['body'])

  return {
    id: rawReview?.id ?? null,
    title: title ?? null,
    body: rawReview?.body ?? null,
    rating: rawReview?.rating ?? 2,
    verified: rawReview?.verified === JUDGEME_VERIFIED_STATUS ?? false,
    productId: rawReview?.product_external_id ?? null,
    date: serializeDate(rawReview?.created_at, locale) ?? null,
    reviewer: serializeReviewReviewer(rawReview?.reviewer) ?? null,
  }
}

export function serializeReviewReviewer(reviewer): ReviewReviewer {
  return {
    name: reviewer?.name ?? null,
  }
}
